import { useEffect, useMemo, useRef } from 'react'
import {
  buildExternalLinksMiniSearchIndex,
  searchExternalLinksMiniSearch,
} from '../local/externalLinksRegistry'

/**
 * BM25 counterpart of ExternalLinksSearchProvider. Runs the curated
 * external/help links through a MiniSearch index and routes results to
 * SupplementarySearchContext under providerId='external-help-minisearch'.
 *
 * Both engines always run; SearchProviderContainer's presentationEngine decides
 * which one consumers present. The non-presented engine still feeds the
 * search-quality report.
 */
function ExternalLinksMiniSearchProvider({ query, options, onResults }) {
  const ms = useMemo(() => buildExternalLinksMiniSearchIndex(), [])

  const onResultsRef = useRef(onResults)
  onResultsRef.current = onResults

  useEffect(() => {
    if (!query) {
      onResultsRef.current({ hits: [] })
      return
    }
    const limit = options && options.hitsPerPage ? options.hitsPerPage : 6
    const hits = searchExternalLinksMiniSearch(ms, query, limit)
    onResultsRef.current({ hits })
  }, [query, ms, options])

  return null
}

export default ExternalLinksMiniSearchProvider
